<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.show_client_request") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <!-- ==== Start:: Status Badges ==== -->

      <!-- ==== End:: Status Badges ==== -->
      <form>
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <div class="preview-container text-center my-3">
            <img
              v-if="data.image?.path"
              col="12"
              :src="data.image?.path"
              :alt="$t('PLACEHOLDERS.personalImage')"
            />
          </div>
          <!-- End:: Image Upload Input -->

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.name')"
            v-model.trim="data.name"
            disabled
          />

          <base-input
            col="6"
            type="text"
            v-model="data.phone"
            :placeholder="$t('PLACEHOLDERS.phone')"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.commercial_register')"
            v-model.trim="data.commercial_register"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.area')"
            v-model.trim="data.region"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.city')"
            v-model.trim="data.city"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.district')"
            v-model.trim="data.neighborhood"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.postal_code')"
            v-model.trim="data.postal_code"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.building_number')"
            v-model.trim="data.building_number"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.commercial_number')"
            v-model.trim="data.tax_number"
            disabled
          />
          <base-select-input
            col="6"
            disabled
            :placeholder="$t('PLACEHOLDERS.business_activity_type')"
            v-model.trim="data.business_activity_type"
            :optionsList="businessActivityTypes"
          />
          <p class="mb-5 px-3" style="color: #072e68; font-size: 16px">
            {{ $t("PLACEHOLDERS.location_on_map")
            }}<span class="text-danger"> * </span>
          </p>
          <MapComponent
            :lat="parseFloat(data.lat)"
            :lng="parseFloat(data.lng)"
            disabled
          />
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BasePhoneInput from "@/components/formInputs/BasePhoneInput.vue";
import MapComponent from "../../../components/formInputs/MapComponent.vue";

export default {
  name: "CreateClient",
  components: {
    BasePhoneInput,
    MapComponent,
  },
  computed: {
    businessActivityTypes() {
      return [
        { id: "restaurant", name: this.$t("BUSINESS_TYPE.restaurant") },
        { id: "cafe", name: this.$t("BUSINESS_TYPE.cafe") },
        {
          id: "hotel_restaurant",
          name: this.$t("BUSINESS_TYPE.hotel_restaurant"),
        },
        { id: "supermarket", name: this.$t("BUSINESS_TYPE.supermarket") },
      ];
    },
  },
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      specializations: [],
      academic_stages: [],
      academic_years: [],

      // Start:: Data Collection To Send
      data: {
        first_name: null,
        last_name: null,
        postal_code: null,
        building_number: null,
        image: {
          path: null,
          file: null,
        

},
        name: null,
        iban: null,
        email: null,
        tax_number: null,
        business_activity_type: null,
        phone: null,
        active: true,
        iban: null,
        commercial_register: null,
        region: null,
        city: null,
        neighborhood: null,
        lat: null,
        lng: null,
        gender: null,
      },
      // End:: Data Collection To Send
    };
  },

  methods: {
    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    // End:: Select Upload Image

    async getData() {
      try {
        this.loading = true;
        let res = await this.$axios({
          method: "GET",
          url: `client-joining/${this.$route.params?.id}`,
        });
        // Start:: Set Data
        this.data.name = res.data.data?.data?.name;
        this.data.phone = res.data.data?.data?.mobile;
        this.data.commercial_register =
          res.data.data?.data?.user_info.commercial_register;
        this.data.neighborhood = res.data.data?.data?.address.neighborhood.name;
        this.data.business_activity_type =
          this.businessActivityTypes.find(
            (type) =>
              type.id === res.data.data?.data?.user_info?.business_activity_type
          ) || null;

        this.data.city = res.data.data?.data?.address.neighborhood.city.name;
        this.data.region =
          res.data.data?.data?.address.neighborhood.city.region.name;
        this.data.lat = res.data.data?.data?.address?.lat;
        this.data.lng = res.data.data?.data?.address?.long;
        this.data.building_number =
          res.data.data?.data?.user_info?.building_number;
        this.data.postal_code = res.data.data?.data?.user_info?.postal_code;

        this.data.tax_number = res.data.data?.data?.user_info?.tax_number;

        // End:: Set Data
      } catch (error) {
        console.log(error.response.data.message);
      
        this.loading = false;}
    },
  },

  async created() {
    this.getData();
    this.$nextTick(() => {
      this.data.phone = "";
    });
  },
};
</script>
<style>
.btn_wallet {
  color: rgb(49, 145, 58);
  padding: 8px 12px;
  border-radius: 4px;
  background: transparent;
  transition: all 0.3s ease;
}

.fad:before,
.fad:after {
  font-size: 22px;
}

.excel {
  background: darkgreen;
  padding: 7px 10px;
  border-radius: 12px;
  color: #fff;
  cursor: pointer;
}
</style>
